import { SKIPPED } from '@datadog/browser-core';
import { RumEventType } from '@datadog/browser-rum-core';
export function startProfilingContext(hooks) {
  var currentContext = {
    status: 'starting'
  };
  hooks.register(0 /* HookNames.Assemble */, function (_ref) {
    var eventType = _ref.eventType;
    if (eventType !== RumEventType.VIEW && eventType !== RumEventType.LONG_TASK && eventType !== RumEventType.ACTION && eventType !== RumEventType.VITAL) {
      return SKIPPED;
    }
    return {
      type: eventType,
      _dd: {
        profiling: currentContext
      }
    };
  });
  return {
    get: function get() {
      return currentContext;
    },
    set: function set(newContext) {
      currentContext = newContext;
    }
  };
}